var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2394_4084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33288 5.31866L14.1355 1.54475L10.4907 0.0474178C10.3367 -0.0158059 10.1641 -0.0158059 10.0102 0.0474178L1.25586 3.64378L5.33288 5.31866Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7741 2.21875L6.96875 5.99155L10.2507 7.33983L19.2453 3.64476L15.7741 2.21875Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61689 8.44192L6.05475 6.97856V9.74926C6.05475 10.0984 5.77166 10.3815 5.42251 10.3815C5.07336 10.3815 4.79027 10.0984 4.79027 9.74926V6.4591L0.687012 4.77344V15.9035C0.687012 16.1599 0.841831 16.3909 1.079 16.4883L9.61689 19.9958V8.44192Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8823 8.44192V19.9958L19.4202 16.4883C19.6574 16.3909 19.8122 16.1599 19.8122 15.9035C19.8122 15.4781 19.8122 5.23912 19.8122 4.77344L10.8823 8.44192Z",
    fill: "#1D4650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2394_4084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageV2);
export default __webpack_public_path__ + "static/media/packageV2.49aefa99c8f9e9a6210531a96d601455.svg";
export { ForwardRef as ReactComponent };